import { useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Editor } from '@tiptap/core';
import { ReactPageClick } from 'react-page-click';

import { KEYS } from 'components/utils/keys';
import { Tooltip } from 'components/overlay/Tooltip';

import * as styled from '../styles';
import {
  HEADING_OPTIONS,
  activeHeadingOption,
} from '../utils/headingDefinition';

type HeadingToolsOptionsProps = {
  editor: Editor | null;
};

export function HeadingToolsOptions({ editor }: HeadingToolsOptionsProps) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const handleKeyDown = useCallback((event: React.KeyboardEvent) => {
    if (event.keyCode === KEYS.ESCAPE) setOpen(false);
  }, []);

  if (!editor) return null;

  const active = activeHeadingOption(editor);

  return (
    <ReactPageClick notify={() => setOpen(false)}>
      <styled.DropdownWrapper onKeyDown={handleKeyDown}>
        <Tooltip
          color="dark"
          fixed
          position="S"
          content={intl.formatMessage(active.message)}
          padding={0}
        >
          <styled.DropdownButton
            active={active.name !== 'paragraph'}
            onClick={() => setOpen(!open)}
          >
            <styled.Icon icon={active.icon} weight="bold" />
            <styled.CaretIcon icon="CaretDown" weight="bold" />
          </styled.DropdownButton>
        </Tooltip>
        {open && (
          <styled.DropdownMenu>
            {HEADING_OPTIONS.map((option) => (
              <styled.DropdownItem
                key={option.name}
                selected={option.name === active.name}
                onMouseDown={(event: React.MouseEvent) => {
                  event.preventDefault();
                  option.command(editor);
                  setOpen(false);
                }}
              >
                <FormattedMessage {...option.message} />
              </styled.DropdownItem>
            ))}
          </styled.DropdownMenu>
        )}
      </styled.DropdownWrapper>
    </ReactPageClick>
  );
}
